import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../../lib/ep.js';

import ActionLink from '../../builder/ActionLink';
import CookiesAdvise from './CookiesAdvise';

import LeveledHTMLText from '../helpers/LeveledHTMLText.js';

const Container = (props) => {
	const title = props?.title ?? false;
	const description = props?.description ?? false;

	if(description === false || description == '') return null;

	return (
		<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
			{(title !== false) && (
				<LeveledHTMLText
					_class={{other:'promotion_title'}}
				>{title}</LeveledHTMLText>
			)}

			<LeveledHTMLText
				_class={{ other:'fill_description small_labeled_text' }}
			>{description}</LeveledHTMLText>

			{props.children}
		</article>
	)
};

const LegalText = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.pm ?? false;
	if(promotion === false) return null;

	const is_builder = props?.is_builder ?? false;

	const type = props?.type ?? 'toc';
	const [display_layer, setDisplayLayer] = useState(false);

	const toggleLayer = () => {
		setDisplayLayer(!display_layer);
	};

	let has_title;

	if(type == 'cookies') {
		has_title = (cookies_legal_text.indexOf('<h1') != -1) ? true : false;

		let cookies_legal_text = promotion?.cookies ?? false;
		if(cookies_legal_text === false) cookies_legal_text = props?.default_cookies_text ?? false;

		return (
			<Container
				title={(!has_title) ? i18n("Cookie policy") : null}
				description={cookies_legal_text}
				is_builder={is_builder}
			>
				<LeveledHTMLText
					_class={{other:'small_labeled_text gui_not_in_top_small'}}
				>
					<p><FormattedMessage id="Configure the promotions cookies from the {link}." values={{link:<ActionLink onClick={toggleLayer} autotranslate={false}>{i18n("Cookie manager", 'lowercase')}</ActionLink>}} /></p>
				</LeveledHTMLText>

				{(display_layer) && (
					<CookiesAdvise
						{...props}
						whole_layout={true}
						force_view="settings"
						force_close={toggleLayer}
					/>
				)}
			</Container>
		)
	}

	if(type == 'policy') {
		has_title = (promotion.policy.indexOf('<h1') != -1) ? true : false;

		return (
			<Container
				title={(!has_title) ? i18n("Privacy policy") : null}
				description={promotion.policy}
				is_builder={is_builder}
			/>
		)
	}

	has_title = (promotion.toc.indexOf('<h1') != -1) ? true : false;

	return (
		<Container
			title={(!has_title) ? i18n("Terms and conditions") : null}
			description={promotion.toc}
			is_builder={is_builder}
		/>
	)
}

export default injectIntl(LegalText);